import { useAuth } from "hooks/useAuth";
import { useRoutes } from "react-router";
import { getRoutes } from "routes";

const App = () => {
  const { user } = useAuth();
  return useRoutes(getRoutes(user.role));
};

export default App;
